/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getDepartmentList(params) {
        return HttpService.get(environment.API_DEPARTMENT_LIST, {
            params,
        });
    },
    getAllDepartmentList() {
        return HttpService.get(environment.API_DEPARTMENT_SEARCH + '/all');
    },
    getStatus(params) {
        return HttpService.get(environment.API_GET_STATUS, {
            params,
        });
    },

    getMetadataList() {
        return HttpService.get(environment.API_GET_META_DATA);
    },

    // Tab 1
    getDataSubject() {
        return HttpService.get(environment.API_GET_DATA_SUBJECT);
    },

    getAmountDataYear() {
        return HttpService.get(environment.API_GET_AMOUNT_DATA_YEAR);
    },

    getLawFullBasis(type) {
        return HttpService.get(
            environment.API_GET_LAWFULLBASIS + `?lawGroup=${type}`
        );
    },

    updateTab1(payload) {
        return HttpService.put(
            environment.API_GET_INVENTORY_DATAFLOW + '/collect-data',
            payload
        );
    },

    // Tab 2

    updateTab2(payload) {
        return HttpService.put(
            environment.API_GET_INVENTORY_DATAFLOW + '/category-personal-data',
            payload
        );
    },

    getActivityList(id) {
        return HttpService.get(environment.API_GET_ACTIVITY_LIST + id);
    },

    createPolicyList(payload) {
        return HttpService.post(environment.API_GET_POLICY_LIST, payload);
    },

    updatePolicyList(payload) {
        return HttpService.put(environment.API_GET_POLICY_LIST, payload);
    },

    deleteDataFlow(id) {
        return HttpService.delete(environment.API_DELETE_DATAFLOW + `${id}`);
    },

    searchDataFlowList(params) {
        return HttpService.get(environment.API_SEARCH_DATAFLOW_LIST, {
            params,
        });
    },

    // Data Flow
    createDataFlow(payload) {
        return HttpService.post(environment.API_INVENTORY_DATAFLOW, payload);
    },
    editDataFlow(payload) {
        return HttpService.put(environment.API_INVENTORY_DATAFLOW, payload);
    },

    getDataOwner(departmentId) {
        return HttpService.get(environment.API_DATA_OWNER + '/' + departmentId);
    },
    // Detail

    getDataFlowDetail(businessProcessId) {
        return HttpService.get(
            environment.API_GET_INVENTORY_DATAFLOW + '/' + businessProcessId
        );
    },

    getDataBaseDetail(businessProcessId) {
        return HttpService.get(
            environment.API_GET_INVENTORY_DATAFLOW +
                '/database/' +
                businessProcessId
        );
    },

    getDataFlowPermission(businessProcessId) {
        return HttpService.get(
            environment.API_GET_INVENTORY_DATAFLOW +
                '/permission/' +
                businessProcessId
        );
    },
    getInventoryDataFlowInfo(businessProcessId) {
        return HttpService.get(
            environment.API_GET_INVENTORY_DATAFLOW +
                '/info/' +
                businessProcessId
        );
    },
    getDpiaDataFlowInfo(businessProcessId) {
        return HttpService.get(
            environment.API_GET_INVENTORY_DATAFLOW +
                '/dpia/' +
                businessProcessId
        );
    },
    changeStatusDataFlow(payload) {
        return HttpService.put(
            environment.API_GET_INVENTORY_DATAFLOW + '/status',
            payload
        );
    },

    getHistoryDataFlowInfo(params) {
        return HttpService.get(
            environment.API_GET_INVENTORY_DATAFLOW + '/history',
            {
                params,
            }
        );
    },

    getHistoryDetail(params) {
        console.log(params);
        return HttpService.get(
            environment.API_GET_INVENTORY_DATAFLOW + '/history/detail',
            {
                params,
            }
        );
    },
    // Tab 3
    getMasterDocumentType() {
        return HttpService.get(
            environment.API_GET_INVENTORY_DATAFLOW + '/m/document-type'
        );
    },
    addDocumentType(payload) {
        return HttpService.post(
            environment.API_GET_INVENTORY_DATAFLOW + '/document-type',
            payload
        );
    },
    createRefDocument(payload) {
        return HttpService.post(
            environment.API_GET_INVENTORY_DATAFLOW + '/reference-document',
            payload
        );
    },
    updateRefDocument(payload) {
        return HttpService.put(
            environment.API_GET_INVENTORY_DATAFLOW + '/reference-document',
            payload
        );
    },

    // Tab 4
    getMasterStorageLocation() {
        return HttpService.get(
            environment.API_GET_INVENTORY_DATAFLOW + '/m/storage-location'
        );
    },
    createCollectionData(payload) {
        return HttpService.post(
            environment.API_GET_INVENTORY_DATAFLOW +
                '/collect-data-destruction',
            payload
        );
    },
    updateCollectionData(payload) {
        return HttpService.put(
            environment.API_GET_INVENTORY_DATAFLOW +
                '/collect-data-destruction',
            payload
        );
    },

    // Tab 5
    createRemarks(payload) {
        return HttpService.post(
            environment.API_GET_INVENTORY_DATAFLOW + '/remarks',
            payload
        );
    },
    updateRemarks(payload) {
        return HttpService.put(
            environment.API_GET_INVENTORY_DATAFLOW + '/remarks',
            payload
        );
    },

    // Activity
    createActivity(payload) {
        return HttpService.post(
            environment.API_GET_INVENTORY_DATAFLOW + '/activity',
            payload
        );
    },
    editActivity(payload) {
        return HttpService.put(
            environment.API_GET_INVENTORY_DATAFLOW + '/activity',
            payload
        );
    },

    // ActivityList
    deleteActivity(id) {
        return HttpService.delete(environment.API_DELETE_ACTIVITY + `${id}`);
    },

    // Tab 6
    updateTab6(payload) {
        return HttpService.post(
            environment.API_GET_INVENTORY_DATAFLOW + '/diagram',
            payload
        );
    },

    //metadata
    mappingMetadata(payload) {
        return HttpService.put(environment.API_METADATA + '/mapping', payload);
    },
    createMetadata(payload) {
        return HttpService.post(environment.API_METADATA + '/mapping', payload);
    },
    deleteMetadata(referenceId, metadataId) {
        return HttpService.delete(
            environment.API_WFSECURE +
                '/metadata/mapping/' +
                `${referenceId}` +
                '/metadata/' +
                `${metadataId}`
        );
    },

    getSyncDepartmentList(businessProcessId) {
        return HttpService.get(
            environment.API_GET_INVENTORY_DATAFLOW +
                '/department-sync-organize/' +
                businessProcessId
        );
    },

    // data hub

    syncData(payload, onUploadProgress) {
        return HttpService.post(
            environment.API_GET_INVENTORY_DATAFLOW + '/sync-data',
            payload,
            { onUploadProgress }
        );
    },

    updateTabDataBase(payload) {
        return HttpService.put(
            environment.API_GET_INVENTORY_DATAFLOW + '/database',
            payload
        );
    },
    deleteDatabase(businessProcessId) {
        return HttpService.delete(
            environment.API_GET_INVENTORY_DATAFLOW +
                '/database/' +
                businessProcessId
        );
    },
    saveDataSubject(payload) {
        return HttpService.put(
            environment.API_GET_INVENTORY_DATAFLOW_DATA_SUBJECT,
            payload
        );
    },
    deleteDataSubject(dataSubjectId) {
        return HttpService.delete(
            environment.API_GET_INVENTORY_DATAFLOW_DATA_SUBJECT +
                '/' +
                dataSubjectId
        );
    },
    requestRevise(payload) {
        return HttpService.patch(environment.API_GET_REQUEST_REVISE, payload);
    },
    export() {
        return HttpService.get(environment.API_EXPORT_DATAFLOW, {
            responseType: 'blob',
        });
    },

    // Tab Dc Dpo
    createDcDpo(payload) {
        return HttpService.post(
            environment.API_GET_INVENTORY_DATAFLOW + '/dc-dpo',
            payload
        );
    },
    updateDcDpo(payload) {
        return HttpService.put(
            environment.API_GET_INVENTORY_DATAFLOW + '/dc-dpo',
            payload
        );
    },
    // Data owner
    getOwnersDepartment(departmentId) {
        return HttpService.get(
            environment.API_GET_INVENTORY_DATAFLOW +
                '/owner/department/' +
                departmentId
        );
    },
    getOwners(businessProcessId) {
        return HttpService.get(
            environment.API_GET_INVENTORY_DATAFLOW +
                '/owner/' +
                businessProcessId
        );
    },
    updateOwner(payload) {
        return HttpService.post(
            environment.API_GET_INVENTORY_DATAFLOW + '/owner',
            payload
        );
    },
    deleteOwner(businessProcessId, userId) {
        return HttpService.delete(
            environment.API_GET_INVENTORY_DATAFLOW +
                `/owner/${businessProcessId}/user/${userId}`
        );
    },
    updateIsGenerateDataFlow(payload) {
        return HttpService.put(
            environment.API_GET_INVENTORY_DATAFLOW + '/is-generate',
            payload
        );
    },
    getSummary() {
        return HttpService.get(environment.API_GET_SUMMARY);
    },
    getDepartmentDataflow(params) {
        return HttpService.get(
            environment.API_GET_DATA_FLOW + '/summary/department',
            {
                params,
            }
        );
    },
};
